module.exports = __webpack_public_path__ + "static/media/moreval.e9daf188.png";